// extracted by mini-css-extract-plugin
export default {"tabs":"RTTabs-tabs-3F4Xp","pointer":"RTTabs-pointer-1bhOG","inverse":"RTTabs-inverse-1xnzC","navigation":"RTTabs-navigation-2erX-"};